/* ---------------------- Imports ---------------------- */
// Home/HowWeHelp
import BoostYourLiquidityGraphic from './boost-your-liquidity'
import EasyAndFastGraphic from './easy-and-fast'
import GrowYourBusinessGraphic from './grow-your-business'
import NoPaperworkGraphic from './no-paperwork'
import ThereForYouGraphic from './there-for-you'
import TransparentGraphic from './transparent'

// Home/HowItWorks
import AddYourOrderGraphic from './add-your-order'
import BuyerPaysModifiGraphic from './buyer-pays-modifi'
import ModifiPaysSellerGraphic from './modifi-pays-seller'
import RegisterGraphic from './register'
import ShipmentOfGoodsGraphic from './shipment-of-goods'

// Product Pages
import NoCollateralGraphic from './no-collateral'
import PaymentExtensionsGraphic from './payment-extensions'
import PaymentFlexibilityGraphic from './payment-flexibility'
import ProductsExtendGraphic from './products-extend'
import ProductsOrderGraphic from './products-order'
import ProductsPaymentGraphic from './products-payment'
import ProductsPayoutGraphic from './products-payout'
import ProductsRegisterGraphic from './products-register'
import ProductsRepaymentGraphic from './products-repayment'
import ProductsShipmentGraphic from './products-shipment'
import QuickAndEasyGraphic from './quick-and-easy'
import RiskCoverageGraphic from './risk-coverage'

// Careers/OurValues
import GrowTogetherGraphic from './grow-together'
import ImproveEveryDayGraphic from './improve-every-day'
import MakeCustomersHappyGraphic from './make-customers-happy'
import MakeItHappenGraphic from './make-it-happen'
import OwnYourActionsGraphic from './own-your-actions'
import PartnersAreFriendsGraphic from './partners-are-friends'
import PushTheBoundariesGraphic from './push-the-boundaries'
import StraightTalkingGraphic from './straight-talking'

// SignUp
import FirstTradeFreeGraphic from './first-trade-free'
import CnBadgeGraphic from './cn-badge'

/* ---------------------- Exports ---------------------- */

// Home/HowWeHelp
export const BoostYourLiquidity = BoostYourLiquidityGraphic
export const EasyAndFast = EasyAndFastGraphic
export const GrowYourBusiness = GrowYourBusinessGraphic
export const NoPaperwork = NoPaperworkGraphic
export const ThereForYou = ThereForYouGraphic
export const Transparent = TransparentGraphic

// Home/HowItWorks
export const AddYourOrder = AddYourOrderGraphic
export const BuyerPaysModifi = BuyerPaysModifiGraphic
export const ModifiPaysSeller = ModifiPaysSellerGraphic
export const Register = RegisterGraphic
export const ShipmentOfGoods = ShipmentOfGoodsGraphic

// Product Pages
export const NoCollateral = NoCollateralGraphic
export const PaymentExtensions = PaymentExtensionsGraphic
export const PaymentFlexibility = PaymentFlexibilityGraphic
export const ProductsExtend = ProductsExtendGraphic
export const ProductsOrder = ProductsOrderGraphic
export const ProductsPayment = ProductsPaymentGraphic
export const ProductsPayout = ProductsPayoutGraphic
export const ProductsRegister = ProductsRegisterGraphic
export const ProductsRepayment = ProductsRepaymentGraphic
export const ProductsShipment = ProductsShipmentGraphic
export const QuickAndEasy = QuickAndEasyGraphic
export const RiskCoverage = RiskCoverageGraphic

// Careers/OurValues
export const GrowTogether = GrowTogetherGraphic
export const ImproveEveryDay = ImproveEveryDayGraphic
export const MakeCustomersHappy = MakeCustomersHappyGraphic
export const MakeItHappen = MakeItHappenGraphic
export const OwnYourActions = OwnYourActionsGraphic
export const PartnersAreFriends = PartnersAreFriendsGraphic
export const PushTheBoundaries = PushTheBoundariesGraphic
export const StraightTalking = StraightTalkingGraphic

// SignUp
export const FirstTradeFree = FirstTradeFreeGraphic
export const CnBadge = CnBadgeGraphic

export default {
  // Home/HowWeHelp
  BoostYourLiquidity,
  EasyAndFast,
  GrowYourBusiness,
  NoPaperwork,
  ThereForYou,
  Transparent,

  // Home/HowItWorks
  AddYourOrder,
  BuyerPaysModifi,
  ModifiPaysSeller,
  Register,
  ShipmentOfGoods,

  // Product Pages, Landing Pages
  NoCollateral,
  PaymentExtensions,
  PaymentFlexibility,
  ProductsExtend,
  ProductsOrder,
  ProductsPayment,
  ProductsPayout,
  ProductsRegister,
  ProductsRepayment,
  ProductsShipment,
  QuickAndEasy,
  RiskCoverage,

  // Careers/OurValues
  GrowTogether,
  ImproveEveryDay,
  MakeCustomersHappy,
  MakeItHappen,
  OwnYourActions,
  PartnersAreFriends,
  PushTheBoundaries,
  StraightTalking,

  // SignUp
  FirstTradeFree,

  // Home/HowWeHelp
  'boost-your-liquidity': BoostYourLiquidity,
  'easy-and-fast': EasyAndFast,
  'grow-your-business': GrowYourBusiness,
  'no-paperwork': NoPaperwork,
  'there-for-you': ThereForYou,
  transparent: Transparent,

  // Home/HowItWorks
  'add-your-order': AddYourOrder,
  'buyer-pays-modifi': BuyerPaysModifi,
  'modifi-pays-seller': ModifiPaysSeller,
  register: Register,
  'shipment-of-goods': ShipmentOfGoods,

  // Product Pages, Landing Pages
  'no-collateral': NoCollateral,
  'payment-extensions': PaymentExtensions,
  'payment-flexibility': PaymentFlexibility,
  'products-extend': ProductsExtend,
  'products-order': ProductsOrder,
  'products-payment': ProductsPayment,
  'products-payout': ProductsPayout,
  'products-register': ProductsRegister,
  'products-repayment': ProductsRepayment,
  'products-shipment': ProductsShipment,
  'quick-and-easy': QuickAndEasy,
  'risk-coverage': RiskCoverage,

  // Careers/OurValues
  'grow-together': GrowTogether,
  'improve-every-day': ImproveEveryDay,
  'make-customers-happy': MakeCustomersHappy,
  'make-it-happen': MakeItHappen,
  'own-your-actions': OwnYourActions,
  'partners-are-friends': PartnersAreFriends,
  'push-the-boundaries': PushTheBoundaries,
  'straight-talking': StraightTalking,

  // SignUp
  'first-trade-fee': FirstTradeFree,
}
